module.exports = __webpack_public_path__ + "img/seated-forward.5382210c.svg";